import * as types from "../constants";

const pageName = (state = '', action) =>
{
	switch (action.type)
	{
		case types.SET_PAGENAME:
			return action.pageName;
		default:
			return state;
	}
}

export default pageName;